import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  paddingX: 1,
  paddingBottom: 1,
};
